// @ts-nocheck
// create position data
export const CREATE_POSITION_REQUEST = "CREATE_POSITION_REQUEST";
export const CREATE_POSITION_SUCCESS = "CREATE_POSITION_SUCCESS";
export const CREATE_POSITION_FAILURE = "CREATE_POSITION_FAILURE";

// fetch positions data
export const FETCH_POSITION_REQUEST = "FETCH_POSITION_REQUEST";
export const FETCH_POSITION_SUCCESS = "FETCH_POSITION_SUCCESS";
export const FETCH_POSITION_FAILURE = "FETCH_POSITION_FAILURE";

// update position
export const UPDATE_POSITION_REQUEST = "UPDATE_POSITION_REQUEST";
export const UPDATE_POSITION_SUCCESS = "UPDATE_POSITION_SUCCESS";
export const UPDATE_POSITION_FAILURE = "UPDATE_POSITION_FAILURE";

// delete position
export const DELETE_POSITION_REQUEST = "DELETE_POSITION_REQUEST";
export const DELETE_POSITION_SUCCESS = "DELETE_POSITION_SUCCESS";
export const DELETE_POSITION_FAILURE = "DELETE_POSITION_FAILURE";

// get positions by search
export const GET_POSITIONS_BY_SEARCH_REQUEST =
  "GET_POSITIONS_BY_SEARCH_REQUEST";
export const GET_POSITIONS_BY_SEARCH_SUCCESS =
  "GET_POSITIONS_BY_SEARCH_SUCCESS";
export const GET_POSITIONS_BY_SEARCH_FAILURE =
  "GET_POSITIONS_BY_SEARCH_FAILURE";

// edit position status
export const EDIT_POSITION_STATUS_REQUEST = "EDIT_POSITION_STATUS_REQUEST";
export const EDIT_POSITION_STATUS_SUCCESS = "EDIT_POSITION_STATUS_SUCCESS";
export const EDIT_POSITION_STATUS_FAILURE = "EDIT_POSITION_STATUS_FAILURE";

// edit position
export const EDIT_POSITION_REQUEST = "EDIT_POSITION_REQUEST";
export const EDIT_POSITION_SUCCESS = "EDIT_POSITION_SUCCESS";
export const EDIT_POSITION_FAILURE = "EDIT_POSITION_FAILURE";

// search position by text
export const SEARCH_POSITION_BY_TEXT_REQUEST =
  "SEARCH_POSITION_BY_TEXT_REQUEST";
export const SEARCH_POSITION_BY_TEXT_SUCCESS =
  "SEARCH_POSITION_BY_TEXT_SUCCESS";
export const SEARCH_POSITION_BY_TEXT_FAILURE =
  "SEARCH_POSITION_BY_TEXT_FAILURE";

// fetch positions category
export const FETCH_POSITION_CATEGORY_REQUEST =
  "FETCH_POSITION_CATEGORY_REQUEST";
export const FETCH_POSITION_CATEGORY_SUCCESS =
  "FETCH_POSITION_CATEGORY_SUCCESS";
export const FETCH_POSITION_CATEGORY_FAILURE =
  "FETCH_POSITION_CATEGORY_FAILURE";